export const fnChangeCurrency = (value, factor, moneda) => moneda === 1 ? +value : +(value * factor);
export const fnChangeCurrencyRev = (value, factor, moneda) => moneda === 1 ? +(+value * +factor) : +(+value / +factor);